import { PlayerConfig, PlayerStates } from "../GameConfig/PlayerConfig.js";

import Fly from "./states/Fly.js";
import Attack from "./states/Attack.js";
import { GameConfig } from "../GameConfig/GameConfig.js";
import BaseEngineBurst from "../Bursts/player/base-engine-burst.js";

export default class Player {
  constructor(game) {
    this.game = game;

    this.image = new Image();
    this.image.src = PlayerConfig.FullHealth.IMG_SRC;

    this.spriteWidth = PlayerConfig.SPRITE_WIDTH;
    this.spriteHeight = PlayerConfig.SPRITE_HEIGHT;

    this.x = PlayerConfig.INITIAL_X_POS_PX;
    this.y = PlayerConfig.INITIAL_Y_POS_PX;

    this.health = PlayerConfig.INITIAL_HEALTH;

    this.states = [new Fly(this.game), new Attack(this.game)];
    this.currentState = this.states[PlayerStates.FLY];

    this.fps = GameConfig.FPS;
    this.frameTimer = GameConfig.FRAME_TIMER;
    this.frameInterval = GameConfig.FRAME_INTERVAL();

    this.burst = new BaseEngineBurst();
    this.ability = new Set();
  }

  draw(context, deltaTime) {
    if (this.frameTimer > this.frameInterval) {
      if (this.frameX < this.maxFrame) this.frameX++;
      else this.frameX = 0;
      this.frameTimer = 0;
    } else if (typeof deltaTime == "number") {
      this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
    }

    this.burst.draw(context, deltaTime);

    this.ability.forEach((ability) => {
      ability.draw(context, deltaTime);
    });

    context.drawImage(
      this.image,
      this.x,
      this.y,
      this.spriteWidth,
      this.spriteHeight,
    );
  }

  update(input) {
    if (this.health > PlayerConfig.FullHealth.LowHealth) {
      this.image.src = PlayerConfig.FullHealth.IMG_SRC;
    } else if (
      this.health <= PlayerConfig.SlightDamage.HighHealth &&
      this.health > PlayerConfig.SlightDamage.LowHealth
    ) {
      this.image.src = PlayerConfig.SlightDamage.IMG_SRC;
    } else if (
      this.health <= PlayerConfig.MidDamage.HighHealth &&
      this.health > PlayerConfig.MidDamage.LowHealth
    ) {
      this.image.src = PlayerConfig.MidDamage.IMG_SRC;
    } else if (this.health <= PlayerConfig.HighDamage.HighHealth) {
      this.image.src = PlayerConfig.HighDamage.IMG_SRC;
    }

    this.currentState.handleInput(input);

    this.burst.update(this.x, this.y);

    // Boundaries
    if (this.y < 0) {
      this.y = 0;
    }
    if (this.y >= this.game.gameHeight - this.spriteHeight) {
      this.y = this.game.gameHeight - this.spriteHeight;
    }

    this.ability.forEach((ability) => {
      ability.update(this.x, this.y);
    });
  }

  setState(state) {
    this.currentState = this.states[state];
    this.currentState.enter();
  }
}
